import { SHOWROOM_PAGE_SLUG } from 'constants/common'

export const isShowroomPage = ({
  slug,
  isShowroomIndexPage,
}: {
  slug: string
  isShowroomIndexPage?: boolean
}) => slug === SHOWROOM_PAGE_SLUG && !isShowroomIndexPage
